import { render, staticRenderFns } from "./qwjs.vue?vue&type=template&id=90fa5ab8&scoped=true"
import script from "./qwjs.vue?vue&type=script&lang=js"
export * from "./qwjs.vue?vue&type=script&lang=js"
import style0 from "./qwjs.vue?vue&type=style&index=0&id=90fa5ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fa5ab8",
  null
  
)

export default component.exports